import {
  GET_OT_LINES,
  GET_OT_LINES_SUCCESS,
  GET_OT_LINES_FAILURE,
} from '../actions/otLines';

const INITIAL_STATE = { loading: true };

export default function otLinesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_OT_LINES:
      return {
        ...state,
        loading: true,
      };
    case GET_OT_LINES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        otLines: action.payload,
      };
    case GET_OT_LINES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
